import { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import useLocalStorage from './useLocalStorage';

export interface UserData {
  role?: number;
  [key: string]: any;
}

function useUser(key: string): UserData {
  const [token] = useLocalStorage(key, '');

  return useMemo<UserData>(() => {
    try {
      if (!token) return {};
      return jwtDecode<UserData>(token);
    } catch (error) {
      console.warn(`Failed to decode user from ${key}:`, error);
      return {};
    }
  }, [key, token]);
}

export default useUser;
